import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _roomsCountSelectorOp;

/**
 * Данные для фильтра комнатности
 * Маппер для технических нужд, может быть полезен в целевом мкс
 * */
export var ERoomCount;

(function (ERoomCount) {
  ERoomCount[ERoomCount["Studio"] = 9] = "Studio";
  ERoomCount[ERoomCount["OneRoom"] = 1] = "OneRoom";
  ERoomCount[ERoomCount["TwoRoom"] = 2] = "TwoRoom";
  ERoomCount[ERoomCount["ThreeRoom"] = 3] = "ThreeRoom";
  ERoomCount[ERoomCount["FourRoom"] = 4] = "FourRoom";
})(ERoomCount || (ERoomCount = {}));

export var roomsCountSelectorOptions = (_roomsCountSelectorOp = {}, _defineProperty(_roomsCountSelectorOp, ERoomCount.Studio, {
  label: 'Студия',
  selectedLabel: 'Студия',
  value: ERoomCount.Studio
}), _defineProperty(_roomsCountSelectorOp, ERoomCount.OneRoom, {
  label: '1',
  selectedLabel: '1 комн.',
  value: ERoomCount.OneRoom
}), _defineProperty(_roomsCountSelectorOp, ERoomCount.TwoRoom, {
  label: '2',
  selectedLabel: '2 комн.',
  value: ERoomCount.TwoRoom
}), _defineProperty(_roomsCountSelectorOp, ERoomCount.ThreeRoom, {
  label: '3',
  selectedLabel: '3 комн.',
  value: ERoomCount.ThreeRoom
}), _defineProperty(_roomsCountSelectorOp, ERoomCount.FourRoom, {
  label: '4+',
  selectedLabel: '4+ комн.',
  value: ERoomCount.FourRoom
}), _roomsCountSelectorOp);
export var sortRuleRoomsCount = [ERoomCount.Studio, ERoomCount.OneRoom, ERoomCount.TwoRoom, ERoomCount.ThreeRoom, ERoomCount.FourRoom];
export var roomCountMapper = ['studio', 'oneRoom', 'twoRoom', 'threeRoom', 'fourRoom'];